<!--
 * @Description: 企业选择
 * @Author: lijinpeng
 * @Date: 2022-03-19 10:41:36
 * @LastEditors: WangYuhan
-->
<template>
  <div class="nf-group">
    <div v-if="type === 'dropdown'" class="nf-group-dropdown flexCon flexAlignCenter">
      <img src="@/assets/images/icons/company.png" />
      <el-dropdown placement="bottom-start" trigger="click" @command="handleSelectGroup">
        <span class="el-dropdown-link Semibold font_600 _181818 pointer">
          {{ selectGroup.principalPartName | filterTestCorp }}
          <i class="el-icon-caret-bottom transBox"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="group of groupList"
            :key="group.businessId"
            :command="group.businessId"
          >
            {{ group.principalPartName | filterTestCorp }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-select
      v-if="type === 'select'"
      v-model="businessId"
      class="nf-group-select"
      placeholder="请选择公司"
      size="small"
      @change="handleSelectGroup"
    >
      <template v-for="group of groupList">
        <el-option
          :key="group.businessId"
          :label="group.principalPartName | filterTestCorp"
          :value="group.businessId"
        />
      </template>
      <el-option
        v-if="isTotas"
        disabled
        label="仅可选通过实名认证且开通网货的企业"
        style="bordertop: 1px solid #d8d9e1; color: #181818; background: #f4f7fa"
        value="仅可选通过实名认证且开通网货的企业"
      />
    </el-select>
  </div>
</template>
<script>
import { getGroups } from '@/api/common';

export default {
  name: 'NfGroupSelect',
  props: {
    value: [String, Number],
    // 企业选择类型
    type: {
      type: String,
      default: 'select',
    },
    // 是否初始化执行
    immediate: {
      type: Boolean,
      default: true,
    },
    // 是否只展示实名企业
    isRealName: {
      type: Boolean,
      default: true,
    },
    // 是否只展示签署协议企业
    isContractSigned: {
      type: Boolean,
      default: false,
    },
    // 是否展示仅可选通过实名认证且开通网货的企业
    isTotas: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupList: [], // 企业列表
      businessId: '', // 选中的企业ID
      selectGroup: {}, // 选中的企业
    };
  },
  created() {
    this.initGroups();
  },
  methods: {
    async initGroups() {
      try {
        const { code, data } = await getGroups();
        if (code === 200) {
          const { value, immediate, isRealName, isContractSigned, isTotas } = this.$props;
          if (isTotas) {
            // 只展示实名认证且开通网货的企业列表
            this.groupList = data.corporations.filter(
              item => item.contractSignedStatus === '1' && item.realtimeChannelInfoId,
            );
          } else if (isContractSigned) {
            // 只展示签署协议的企业列表
            this.groupList = data.corporations.filter(item => item.contractSignedStatus === '1');
          } else if (isRealName) {
            // 只展示实名认证的企业列表
            this.groupList = data.corporations.filter(item => item.realNameAudit === 1);
          } else {
            // 全部展示
            this.groupList = data.corporations;
          }
          // 是否立即执行
          if (immediate) {
            if (value) {
              // 有默认值
              this.selectGroup = this.groupList.find(group => group.businessId === value);
            } else {
              // 没有默认值

              const defaultIndex = this.groupList.findIndex(item => item.isDefault === 1);
              if (defaultIndex > -1) {
                this.selectGroup = this.groupList[defaultIndex];
              } else {
                this.selectGroup = this.groupList[0];
              }
            }
            this.businessId = this.selectGroup.businessId;
            this.$emit('input', this.businessId);
            this.$emit('change', this.selectGroup);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleSelectGroup(businessId) {
      // 当前选中公司
      this.selectGroup = this.groupList.find(item => {
        return item.businessId === businessId;
      });
      this.businessId = this.selectGroup.businessId;
      this.$emit('input', this.businessId);
      this.$emit('change', this.selectGroup);
    },
  },
};
</script>
<style lang="scss" scoped>
.nf-group {
  display: inline-block;

  ::v-deep .el-input,
  ::v-deep .el-select,
  ::v-deep .el-autocomplete {
    width: 100%;
  }

  &-dropdown {
    background: #ffffff;

    img {
      width: 19px;
      height: 18px;
      margin: 20px 10px 21px 15px;
    }

    .el-dropdown-link {
      background-color: transparent;
      font-size: 18px;

      i {
        margin-left: 10px;
      }
    }
  }
}
</style>
